<template>
  <div class="steps">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'Steps',
  components: {},
  props: {
    //每个 step 的间距，不填写将自适应间距。支持百分比。
    space: {
      type: [Number, String],
    },
    //步骤线的样式
    lineCustomStyle: {
      type: Object,
      default: () => {}
    },
    //步骤图标的样式
    iconCustomStyle: {
      type: Object,
      default: () => {},
    }
  },
  data() {
    return {
      steps: [],
    }
  },
  methods: {},
}
</script>
<style lang="less" scoped>
.steps {
  display: flex;
  flex-direction: column;
  height: 100%;
}
</style>
